module.exports = __webpack_public_path__ + "img/ru.e2037a0e.svg";